import React from 'react';
import Text from '@service-victoria/component-library/components/Text';
import List from '@service-victoria/component-library/components/List';

import * as Styled from '../../styled';

export interface AssessTechnicalErrorProps {
  onClick: () => void;
}

export default function AssessTechnicalError({ onClick }: AssessTechnicalErrorProps) {
  return (
    <Styled.Wrapper isHideFormOptions>
      <Text.Heading.H1 fontWeight={600}>
        There&apos;s a problem fetching the latest data
      </Text.Heading.H1>
      <Text.Body>
        Please{' '}
        <Text.Link
          onClick={e => {
            e.preventDefault();
            onClick();
          }}>
          click here
        </Text.Link>{' '}
        to try again.
      </Text.Body>
      <Text.Body>What might be causing this:</Text.Body>
      <List
        items={[
          'no network connectivity',
          'a browser plugin blocking the requests',
          'poor network coverage where you are'
        ]}
        type='disc'
      />
    </Styled.Wrapper>
  );
}
